module.exports = __webpack_public_path__ + "ingela.jpg?712ae629aeeed3ad7db534fc6a719c55";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artists/ingela.jpg
// module id = 11
// module chunks = 0